// create first-party session cookie for authentication with 1 year expiry
export function setSessionCookie(token: string) {
    document.cookie = `eight-wave-ai=${token}; path=/; max-age=31536000; SameSite=Lax; Secure`
}

// retrieve first-party session cookie
export function getSessionCookie() {
    return (
        document.cookie
            .split('; ')
            .find((row) => row.startsWith('eight-wave-ai='))
            ?.split('=')[1] ?? ''
    )
}
